import React from 'react';
import BasePage from '@/components/BasePage';
import BaseLayout from '@/components/layouts/BaseLayout';
import BasicCountryLink from '@/Handlers/BasicCountryLink';
import Booking from '@/components/Booking';
import { Container } from 'reactstrap';

// Translation Higher Order Component
import { translate } from 'react-switch-lang';
const Advice = ({ t }) => {
	return (
		//React.Fragment is used instead of <div> or <> to hide it from source
		<React.Fragment>
			<BaseLayout
				className="cover"
				title={t('advice.title')}
				description={t('advice.title_text')}
				keywords={`${t('SEO.keywords_common')} ${t('SEO.keywords_advice')}`}
				canonical="/advice"
			>
				{/* Base Page - Shared component with Container */}
				<BasePage id="advice-page" className="advice-page" role="article">
					<Container>
						<article>
							<h1 className="page_text font-weight-bold">{t('advice.title')}</h1>
							<p>{t('advice.title_text')}</p>
							<hr className="vaccination-page_hr" />
							<h2>{t('advice.before_trip')}</h2>
							<h3 className="page_subtext text-uppercase">{t('advice.before_trip_title1')}</h3>
							<p>{t('advice.before_trip_text2')}</p>
							<p>{t('advice.before_trip_text3')}</p>
							<p>
								<BasicCountryLink className="country_list clickable country_links style_italic"
									title={t('advice.before_trip_text4')}
									photo="/images/countries/denmark.webp"
									vaccines={[ 'tetanus', 'diphtheria' ]}
									country={'Europe.Denmark.title'}
									text1={'Europe.Denmark.text1'}
									text2={'Europe.Denmark.text2'}
									map_lat="55.85064987433714"
									map_long="9.624023437500002"
								/>
							</p>
							<h3 className="page_subtext text-uppercase">
								<strong>{t('advice.before_trip_title2')}</strong>
							</h3>
							<p>
								<span>{t('advice.before_trip_text5')}</span>
							</p>
							<p>
								<span>{t('advice.before_trip_text6')}</span>
							</p>
							<p>
								<a
									className="country_links style_italic"
									rel="external nofollow noopener"
									href="http://www.sygeforsikring.dk/Default.aspx"
									target="_blank"
								>
									{t('advice.before_trip_text7')}
								</a>
							</p>
							<h3 className="page_subtext text-uppercase">{t('advice.before_trip_title3')}</h3>
							<p>{t('advice.before_trip_text8')}</p>
							<p>
								<a
									className="country_links style_italic"
									rel="external nofollow noopener"
									href="https://www.borger.dk/"
									target="_blank"
								>
									{t('advice.before_trip_text9')}
								</a>
							</p>
							<p>{t('advice.before_trip_text10')}</p>
							<h3 className="page_subtext text-uppercase">{t('advice.before_trip_title4')}</h3>
							<p>{t('advice.before_trip_text11')}</p>
							<p>{t('advice.before_trip_text12')}</p>
							<h3 className="page_subtext text-uppercase">{t('advice.before_trip_title5')}</h3>
							<p>{t('advice.before_trip_text13')}</p>
							<p>{t('advice.before_trip_text14')}</p>
							<h3 className="page_subtext text-uppercase">{t('advice.before_trip_title6')}</h3>
							<p>{t('advice.before_trip_text15')}</p>
							<p>
								<a
									className="country_links style_italic"
									rel="external nofollow noopener"
									href="http://um.dk/da/rejse-og-ophold/rejse-til-udlandet/rejsevejledninger/"
									target="_blank"
								>
									{t('advice.before_trip_text16')}
								</a>
							</p>
							<Booking />
							<hr className="vaccination-page_hr" />
							<h2>{t('advice.during_trip')}</h2>
							<h3 className="page_subtext text-uppercase">{t('advice.during_trip_title1')}</h3>
							<p>{t('advice.during_trip_text1')}</p>
							<h3 className="page_subtext text-uppercase">{t('advice.during_trip_title2')}</h3>
							<p>{t('advice.during_trip_text2')}</p>
							<h3 className="page_subtext text-uppercase">{t('advice.during_trip_title3')}</h3>
							<p>{t('advice.during_trip_text4')}</p>
							<p>{t('advice.during_trip_text5')}</p>
							<ul>
								<li>{t('advice.during_trip_text6')}</li>
								<li>{t('advice.during_trip_text7')}</li>
								<li>{t('advice.during_trip_text8')}</li>
								<li>{t('advice.during_trip_text9')}</li>
								<li>{t('advice.during_trip_text10')}</li>
								<li>{t('advice.during_trip_text11')}</li>
								<li>{t('advice.during_trip_text12')}</li>
							</ul>
							<h3 className="page_subtext text-uppercase">{t('advice.during_trip_title4')}</h3>
							<p>{t('advice.during_trip_text13')}</p>
							<h3 className="page_subtext text-uppercase">{t('advice.during_trip_title5')}</h3>
							<p>{t('advice.during_trip_text14')}</p>
							<hr className="vaccination-page_hr" />
							<h2>{t('advice.after_trip')}</h2>
							<p>{t('advice.after_trip_text')}</p>
							<Booking />
						</article>
					</Container>
				</BasePage>
			</BaseLayout>
		</React.Fragment>
	);
};
export default translate(Advice);
